import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FolderIcon from '@material-ui/icons/Folder';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PdfWage from './PdfWage';
import { listDistributedDocuments, confirmOpenningDocument } from '../../actions/wage/listWage';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import i18next from 'i18next';
import * as StatusCode from '../../scripts/StatusCode';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../utils/language';
import { formatDate } from '../../utils';
import { format } from 'react-string-format';
import styles from '../../styles/listWage.module.css';
import AlertAlgo from '../controls/AlertSnack'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen, faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";

class ListDistributedDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            documentCategory: [],
            document: [],
            expanded: [],
            filename: '',
            title: '',
            openPdf: false,
            isActive: true,
            isRequired: false,
            confirmed: false,
            documentEmployeeId: 0
        };
        this.alert = React.createRef();
    }

    componentDidMount() {
        this.loadData();
        this.resizeList();
    }

    loadData() {
        listDistributedDocuments().then((response) => {
            if (response.status === StatusCode.STATUS_INTERNALSERVERERROR) {
                throw 'error';
            }
            let list = JSON.parse(response.list);
            list = this.manageData(list);

            let documentCategories = [];

            Array.from(new Set(list.map((item) => item.documentCategoryCode))).forEach(item => {
                const filterdList = list.filter(item2 => item2.documentCategoryCode === item);
                documentCategories.push({ code: item, desc: filterdList[0].documentCategoryDesc });
            });

            let expandedList = [];
            documentCategories.forEach(item => {
                expandedList.push(item.code);
            });

            this.setState({ data: list, isActive: false, documentCategory: documentCategories.sort((a, b) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0)), expanded: expandedList });
        }).catch(error => {
            this.setState({ isActive: false });
            this.alert.current.showMessageError(i18next.t('error:generic-error'));
        });
    }

    manageData = (list) => {
        list.forEach(item => {
            if (item.documentCategoryCode === null) {
                item.documentCategoryCode = i18next.t('documents:none');
                item.documentCategoryDesc = i18next.t('documents:without-category');
            } else {
                item.documentCategoryDesc = IsEnglish() ? item.documentCategoryDescriptionEnglish : item.documentCategoryDescriptionFrench;
            }
        });
        return list;
    }

    loadDocument = (id) => {
        return new Promise(resolve => {
            const list = this.state.data.filter(item => item.documentId == id);

            const obj = list[0];

            this.setState({ document: obj.document, filename: obj.filename, isRequired: obj.confirmationRequired }, () => resolve());
        })
    }

    handleClick = async (documentId, documentEmployeeId, confirmed, description) => {
        if (documentId != null) {
            await this.loadDocument(documentId);
            await this.handleConfirmOpenning(documentEmployeeId);
            this.setState(
                {
                    openPdf: true,
                    documentEmployeeId: documentEmployeeId,
                    confirmed: confirmed,
                    title: description
                });
        }
    }

    handleConfirmOpenning = (documentEmployeeId) => {
        return new Promise(async (resolve) => {
            const response = await confirmOpenningDocument(documentEmployeeId);
            if (response === undefined || response.status !== StatusCode.STATUS_OK) {
                this.alert.current.showMessageError(i18next.t('error:generic-error'));
            }

            resolve();
        })
    }

    handleClosePdf = (isRequired, isConfirmed) => {
        if (isRequired) {
            this.loadData();
        }

        if (isRequired && !isConfirmed) {
            this.alert.current.showMessageWarning(i18next.t('documents:warning-reading-not-confirm'));
        }

        this.setState({ openPdf: false });
    };

    resizeList() {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;

            const header = document.querySelector('div[data-id=headerSchedule]').offsetHeight;

            const offSet = 50;

            const customHeight = height - header - titleBar - offSet;

            const element = document.querySelector('#divAllDocuments');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    handleAccordion = (index) => () => {
        let expandedList = this.state.expanded;

        if (expandedList.includes(index)) {
            expandedList = expandedList.filter(d => d !== index);
        } else {
            expandedList.push(index);
        }

        this.setState({ expanded: expandedList });
    };

    render() {
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('punch:form.loading')}
            >
                <div id="divAllDocuments" className={styles.konekCard}>
                    {this.state.documentCategory !== null && this.state.documentCategory.map((catObj, catIndex) =>
                        <React.Fragment key={catIndex}>
                            <Accordion expanded={this.state.expanded.includes(catObj.code)} onChange={this.handleAccordion(catObj.code)}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon className={styles.iconAccordion} />}
                                    aria-controls={`panel2${catIndex}-content`}
                                    id={`panel${catIndex}-header`}
                                    className={styles.accordionSummary}
                                >
                                    <div>{`${catObj.code} - ${catObj.desc}`}</div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div id={`listDistributedDocument${catIndex}`}>
                                        <List>
                                            {this.state.data !== null && this.state.data.filter(d => d.documentCategoryCode === catObj.code).map((obj, index) =>
                                                <React.Fragment key={index}>
                                                    <div className="listItem">
                                                        <ListItem key={index} button onClick={() => this.handleClick(obj.documentId, obj.documentEmployeeId, obj.readConfirmation, IsEnglish() ? obj.descriptionEnglish : obj.descriptionFrench)}>
                                                            <ListItemIcon className={styles.iconList}>
                                                                {!obj.confirmationRequired ? <FontAwesomeIcon icon={faFolderOpen} style={{ width: "20px", height: "20px", marginRight: "5px" }} /> : obj.readConfirmation ? <FontAwesomeIcon icon={faEye} style={{ width: "20px", height: "20px", marginRight: "5px" }} /> : <FontAwesomeIcon icon={faEyeSlash} style={{ width: "20px", height: "20px", marginRight: "5px" }} />}
                                                            </ListItemIcon>
                                                            <ListItemText primary={format('{0} - {1}', (IsEnglish() ? obj.descriptionEnglish : obj.descriptionFrench), obj.filename)} secondary={
                                                                <React.Fragment>
                                                                    <label>{`${i18next.t('wage:distributed.creation-date')}${i18next.t('common:labelSeparator')} ${formatDate(obj.datetimeCreated)}`}</label>
                                                                </React.Fragment>
                                                            } />
                                                        </ListItem>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </List>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <PdfWage
                                open={this.state.openPdf}
                                onClose={this.handleClosePdf}
                                pdfData={this.state.document}
                                filename={this.state.filename}
                                required={this.state.isRequired}
                                id={this.state.documentEmployeeId}
                                confirmed={this.state.confirmed}
                                title={this.state.title}
                            />

                            <AlertAlgo ref={this.alert} />
                        </React.Fragment>
                    )}
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['wage', 'documents', 'common'], { wait: true })(ListDistributedDocuments);